import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Overlay from './Overlay';
import { sendTextMessage } from '../../reducers/history/actions';

const ButtonWrapper = styled.div`
  padding: 4px 8px;
  margin: 0 5px 4px 5px;
  border-radius: 20px;
  background: ${props => props.theme.botCardButtonBackgroundColor};
  border: 2px solid ${props => props.theme.botCardButtonOutlineColor};
  width: 100px;
  height: 35px;
  color: ${props => props.theme.botCardButtonTextColor};
  min-width: 30px;
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  &:hover {
    background-color: ${props => props.theme.hoverColor};
  }
`;

const MessageWrapper = styled.div`
  background: ${props => props.theme.backgroundColor};
  color: ${props => props.theme.botMessageFontColor};
  font-size: 16px;
  line-height: 1.4;
  padding: 15px;
  margin: 0 30px;
  border-radius: 10px;
  border: 1px solid ${props => props.theme.accentColor};
`;

const EndConfirmDialog = ({
  overlayDiv,
  headerDiv,
  showOverlay,
  setShowOverlay,
  clearHistory,
  sendTextMessage,
  inputFieldRef
}) => {
  useEffect(
    () => {
      if (showOverlay) {
        inputFieldRef.current.focus();
      }
    },
    [showOverlay]
  );

  const okPressed = () => {
    setShowOverlay(false);
    clearHistory();
    sendTextMessage({ text: '/end' });
    inputFieldRef.current.focus();
  };

  const cancelPressed = () => {
    setShowOverlay(false);
    inputFieldRef.current.focus();
  };

  return (
    <Overlay
      showOverlay={showOverlay}
      overlayDiv={overlayDiv}
      headerDiv={headerDiv}
      backgroundColour={'rgba(0, 0, 0, 0.3)'}
      opacityForDiv={0.3}
    >
      {/* Below children are child-windows to be seen on the overlay */}
      <MessageWrapper>
        <div>
          Ending your conversation will clear all your previous conversation history - do you want
          to continue?
        </div>
        <div>&nbsp;</div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <ButtonWrapper onClick={cancelPressed}>Cancel</ButtonWrapper>
          <ButtonWrapper onClick={okPressed}>Confirm</ButtonWrapper>
        </div>
      </MessageWrapper>

      <div style={{ height: '100px' }} />
    </Overlay>
  );
};

export default connect(
  state => ({
    inputFieldRef: state.ui.inputFieldRef
  }),
  { sendTextMessage }
)(EndConfirmDialog);



// WEBPACK FOOTER //
// ./src/components/ChatPanel/EndConfirmDialog.js